import { Big } from 'big.js'
import { Measure } from '../types'


enum TimeMeasurementSystem {
  siUnits = 'SI Units',
  commonUnits = 'Common Units',
  longTermUnits = 'Long-term Units'
}

const timeUnits = {
  nanosecond: {
    displayName: 'Nanosecond',
    codeName: 'nanosecond',
    url: 'nanosecond',
    symbol: 'ns',
    toBaseUnit: (value: Big): Big => value.div(1000000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000000),
    system: TimeMeasurementSystem.siUnits
  },
  microsecond: {
    displayName: 'Microsecond',
    codeName: 'microsecond',
    url: 'microsecond',
    symbol: 'μs',
    toBaseUnit: (value: Big): Big => value.div(1000000),
    fromBaseUnit: (value: Big): Big => value.times(1000000),
    system: TimeMeasurementSystem.siUnits
  },
  millisecond: {
    displayName: 'Millisecond',
    codeName: 'millisecond',
    url: 'millisecond',
    symbol: 'ms',
    toBaseUnit: (value: Big): Big => value.div(1000),
    fromBaseUnit: (value: Big): Big => value.times(1000),
    system: TimeMeasurementSystem.siUnits
  },
  second: {
    displayName: 'Second',
    codeName: 'second',
    url: 'second',
    symbol: 's',
    toBaseUnit: (value: Big): Big => value,
    fromBaseUnit: (value: Big): Big => value,
    system: TimeMeasurementSystem.siUnits
  },
  minute: {
    displayName: 'Minute',
    codeName: 'minute',
    url: 'minute',
    symbol: 'min',
    toBaseUnit: (value: Big): Big => value.times(60),
    fromBaseUnit: (value: Big): Big => value.div(60),
    system: TimeMeasurementSystem.siUnits
  },
  hour: {
    displayName: 'Hour',
    codeName: 'hour',
    url: 'hour',
    symbol: 'hr',
    toBaseUnit: (value: Big): Big => value.times(3600),
    fromBaseUnit: (value: Big): Big => value.div(3600),
    system: TimeMeasurementSystem.siUnits
  },
  day: {
    displayName: 'Day',
    codeName: 'day',
    url: 'day',
    symbol: 'd',
    toBaseUnit: (value: Big): Big => value.times(86400),
    fromBaseUnit: (value: Big): Big => value.div(86400),
    system: TimeMeasurementSystem.commonUnits
  },
  week: {
    displayName: 'Week',
    codeName: 'week',
    url: 'week',
    symbol: 'wk',
    toBaseUnit: (value: Big): Big => value.times(604800),
    fromBaseUnit: (value: Big): Big => value.div(604800),
    system: TimeMeasurementSystem.commonUnits
  },
  month: {
    displayName: 'Month',
    codeName: 'month',
    url: 'month',
    symbol: 'mo',
    toBaseUnit: (value: Big): Big => value.times(2628000),
    fromBaseUnit: (value: Big): Big => value.div(2628000),
    system: TimeMeasurementSystem.commonUnits
  },
  calendar_year: {
    displayName: 'Calendar Year',
    codeName: 'calendar_year',
    url: 'calendar-year',
    symbol: 'yr',
    toBaseUnit: (value: Big): Big => value.times(31536000),
    fromBaseUnit: (value: Big): Big => value.div(31536000),
    system: TimeMeasurementSystem.commonUnits
  },
  decade: {
    displayName: 'Decade',
    codeName: 'decade',
    url: 'decade',
    symbol: 'dec',
    toBaseUnit: (value: Big): Big => value.times(315360000),
    fromBaseUnit: (value: Big): Big => value.div(315360000),
    system: TimeMeasurementSystem.longTermUnits
  },
  century: {
    displayName: 'Century',
    codeName: 'century',
    url: 'century',
    symbol: 'c',
    toBaseUnit: (value: Big): Big => value.times(3153600000),
    fromBaseUnit: (value: Big): Big => value.div(3153600000),
    system: TimeMeasurementSystem.longTermUnits
  }
}

export const time: Measure = {
  displayName: 'Time',
  codeName: 'time',
  url: 'time',
  units: timeUnits,
  baseUnit: timeUnits.second,
  defaultFromUnit: timeUnits.minute,
  defaultToUnit: timeUnits.second
}
